import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  putExtensiveAttributeDefinitions,
  putExtensiveAttributesAppliedContentTags,
} from 'api/extensive-attribute-definition.service';
import { notificationActions } from 'redux/notification/notification.slice';
import { ContentTagIdListRequest, UpdateUserExtensiveAttributeDefinitionsRequest } from 'types/entity';

export const EXTENSIVE_ATTRIBUTE_DEFINITION_UPDATE_STORE_NAME = 'extensiveAttributeDefinitionUpdate';

export interface ExtendiveAttributeDefinitionUpdateState {
  processing: boolean
  error: any
}

export const initialExtensiveAttributeDefinitionUpdateState: ExtendiveAttributeDefinitionUpdateState = {
  processing: false,
  error: null,
};

export const updateExtensiveAttributeDefinitions = createAsyncThunk(
  `${EXTENSIVE_ATTRIBUTE_DEFINITION_UPDATE_STORE_NAME}/update`,
  (payload: { projectId: string, extensiveAttributeDefinitionId: string, attributes: UpdateUserExtensiveAttributeDefinitionsRequest}, thunkAPI) => {
    const { projectId, extensiveAttributeDefinitionId, attributes } = payload;
    return putExtensiveAttributeDefinitions(projectId, extensiveAttributeDefinitionId, attributes)
      .then((data) => {
        thunkAPI.dispatch(notificationActions.addSuccess({ messageId: 'notification.extensiveAttributeDefinitionUpdate.success' }));
        return data;
      });
  },
);

/**
 * 拡張属性適用内容タグ編集
 */
export const putExtensiveAttributeAppliedContentTags = createAsyncThunk(
  `${EXTENSIVE_ATTRIBUTE_DEFINITION_UPDATE_STORE_NAME}/update-content-tags`,
  (payload: { projectId: string, extensiveAttributeDefinitionId: string, contentTagIdList: string[]}, thunkAPI) => {
    const {
      projectId,
      extensiveAttributeDefinitionId,
      contentTagIdList,
    } = payload;
    const contentTagIdListRequest: ContentTagIdListRequest = { content_tag_id: contentTagIdList };
    return putExtensiveAttributesAppliedContentTags(projectId, extensiveAttributeDefinitionId, contentTagIdListRequest)
      .then((content_tag_id: string[]) => {
        thunkAPI.dispatch(notificationActions.addSuccess({ messageId: 'notification.putExtensiveAttributesAppliedContentTags.success' }));
        return content_tag_id;
      });
  },
);

export const extensiveAttributeDefinitionUpdateSlice = createSlice({
  name: EXTENSIVE_ATTRIBUTE_DEFINITION_UPDATE_STORE_NAME,
  initialState: initialExtensiveAttributeDefinitionUpdateState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(updateExtensiveAttributeDefinitions.pending, (state) => {
      state.processing = true;
    });
    builder.addCase(updateExtensiveAttributeDefinitions.fulfilled, (state) => {
      state.processing = false;
    });
    builder.addCase(updateExtensiveAttributeDefinitions.rejected, (state, action) => {
      state.error = action.payload;
      state.processing = false;
    });
    builder.addCase(putExtensiveAttributeAppliedContentTags.pending, (state) => {
      state.processing = true;
    });
    builder.addCase(putExtensiveAttributeAppliedContentTags.fulfilled, (state) => {
      state.processing = false;
    });
    builder.addCase(putExtensiveAttributeAppliedContentTags.rejected, (state, action) => {
      state.error = action.payload;
      state.processing = false;
    });
  },
});

export const extensiveAttributeDefinitionUpdateActions = {
  ...extensiveAttributeDefinitionUpdateSlice.actions,
  putExtensiveAttributeAppliedContentTags,
  updateExtensiveAttributeDefinitions,
};

export default extensiveAttributeDefinitionUpdateSlice.reducer;
